import script from "./menu_item.vue?vue&type=script&setup=true&lang=js"
export * from "./menu_item.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__